import { Component, EventEmitter, Input, OnInit, Output, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { PaymentListSectionModel, PaymentVoucherTypes } from './payment-list.model';
import { AgGridI, PaginationModel } from '../ag-grid/ag-grid.model';
import { FirstDataRenderedEvent, GridOptions, RowClassRules, RowHeightParams } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { AgGridService } from '../ag-grid/ag-grid.service';
import { AgGridComponent } from '../ag-grid/ag-grid.component';
import { ExcelConverterServiceService } from '../../services/excel-converter-service.service';
import { CommonService } from '../../services/common.service';
import { API_URL_GETALLEXPENSES_VOUCHER, API_URL_GETALLINCOMEINVOICE_VOUCHER, API_URL_GETALLMATERIAL_IN_VOUCHER, API_URL_GETALLMATERIAL_OUT_VOUCHER, API_URL_GETALLPAYMENTVOUCHER, API_URL_GETALLRECEIPTVOUCHER } from '../../url-helper/url-helper';
import { ExportAs, ExportDropdownBindDynamicParameter, StorageName } from '../../enum/common-enum';
import { ReportService } from '../../../components/report/report.service';
import { NotificationService } from '../../services/notification.service';
import { MaterialInPaymentlistAdvancedFilterComponent } from '../../../components/transaction/material-in/advanced-filter-popup/advanced-filter-popup.component';
import { MaterialOutPaymentlistAdvancedFilterComponent } from '../../../components/transaction/material-out/advanced-filter-popup/advanced-filter-popup.component';
import { PaymentVoucherAdvancedFilterComponent } from '../../../components/transaction/payment-voucher/advanced-filter-popup/advanced-filter-popup.component';
import { ReceiptVoucherAdvancedFilterComponent } from '../../../components/transaction/receipt-voucher/advanced-filter-popup/advanced-filter-popup.component';
import { StorageService } from '../../services/storage.service';
import { TransactionService } from '../../../components/transaction/transaction.service';
import { CommonFilterService } from '../../services/common-filter.service';
import { FileReaderService } from '../../services/file.reader.service';
import { SendDataService } from '../../services/send-data.service';
import { ExpenseAdvancedFilterPopupComponent } from '../../../components/Transaction/expenses/advanced-filter-popup/advanced-filter-popup.component';
import { IncomeAdvanceFilterPopupComponent } from '../../../components/Transaction/income/advance-filter-popup/advance-filter-popup.component';

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss']
})
export class PaymentListComponent extends CommonService implements OnInit {
  gridApi:any;
  data : any ;
  apiRequestModel : any = {};
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  agGridDataModelPaymentList  : AgGridI;
  pagination = new PaginationModel();
  textClickSubscriptionForTab:Subscription; 
  @Input() voucherType:any;
  totalRecords: number;
  @Input() paymentListSectionModel =new PaymentListSectionModel();
  @Output() onEditIconClicked = new EventEmitter<any>();
  exportAs = ExportAs;
  @Input() getAllDropdownModel  : any = {};
  apiRequestStorageName = StorageName.APIREQUEST_TRANSACTION_PAYMENT_LIST_GRID;
  filterCountValue :any;
  exportDropdownBindDynamicParameter = ExportDropdownBindDynamicParameter;
  constructor(
  public transactionService :TransactionService,
              public  agGridService : AgGridService,
              public renderer : Renderer2,
              private storageService    : StorageService,
              public commonFilterService:CommonFilterService,
              public notificationService : NotificationService,
              public fileReaderService : FileReaderService,
              public sendDataService: SendDataService,
              public excelConverterServiceService : ExcelConverterServiceService)
              {
                super(renderer);
              }

  onGridReady(params: any) 
  {
    this.gridApi  = params; 
    params.api.permission  = this?.sendDataService?.permissionVM;
    params.api.voucherType =  this?.voucherType
    this.setDefaultFilter()
  }

  ngOnInit() {
    const paymentListModel = new PaymentListSectionModel();
    switch (this.voucherType) {
      case PaymentVoucherTypes.ReceiptVoucher:
        this.agGridDataModelPaymentList = paymentListModel?.agGridDataModelRecieptVoucher;
        this.agGridDataModelPaymentList.apiUrl = API_URL_GETALLRECEIPTVOUCHER
        break;
      case PaymentVoucherTypes.PaymentVoucher:
        this.agGridDataModelPaymentList = paymentListModel?.agGridDataModelPaymentVoucher;
        this.agGridDataModelPaymentList.apiUrl = API_URL_GETALLPAYMENTVOUCHER
        break;
      case PaymentVoucherTypes.MaterialIn:
        this.agGridDataModelPaymentList = paymentListModel?.agGridDataModelMaterialIn;
        this.agGridDataModelPaymentList.apiUrl = API_URL_GETALLMATERIAL_IN_VOUCHER
        break;
      case PaymentVoucherTypes.MaterialOut:
        this.agGridDataModelPaymentList = paymentListModel?.agGridDataModelMaterialOut;
        this.agGridDataModelPaymentList.apiUrl = API_URL_GETALLMATERIAL_OUT_VOUCHER
        break;
      case PaymentVoucherTypes.Expense:
        this.agGridDataModelPaymentList = paymentListModel?.agGridDataModelExpenses;
        this.agGridDataModelPaymentList.apiUrl = API_URL_GETALLEXPENSES_VOUCHER
        break;
      case PaymentVoucherTypes.income:
        this.agGridDataModelPaymentList = paymentListModel?.agGridDataModelIncome;
        this.agGridDataModelPaymentList.apiUrl = API_URL_GETALLINCOMEINVOICE_VOUCHER
        break;
    }
  }

  setDefaultFilter() {
    this.commonFilterService.setDefaultFilter(this.apiRequestStorageName, this.apiRequestModel, this.agGridDataModelPaymentList?.filterStorageName);
    this.apiRequestModel.filters = '';
    switch (this.voucherType) {
      case PaymentVoucherTypes.ReceiptVoucher:
      case PaymentVoucherTypes.PaymentVoucher:
      case PaymentVoucherTypes.MaterialIn:
      case PaymentVoucherTypes.MaterialOut: this.filterCountValue = 2;
        break;
      case PaymentVoucherTypes.Expense:
      case PaymentVoucherTypes.income:
        this.filterCountValue = 1;
        break;
    }

    this.getAllVoucherData();
  }

  onEditIconClick(event: any) 
  {
    this.onEditIconClicked.emit(event.detail.data.data.id);
  }

  onDeleteIconClick(event: any) {
    var data = event.detail.data.data;
    this.transactionService.deleteInvoice(data.voucherType,data.id).subscribe({
      next: (res) => {
      if(res?.isSuccess) this.gridApi.api.applyTransaction({ remove: [data] });
      this.getAllVoucherData();
      },error: (err) => { }})
  }

  getAllVoucherData()  {
    this.showLoading(this.gridApi);
    this.apiRequestModel = this.storageService.retrieve(this.apiRequestStorageName);
    this.transactionService.getAll(this.apiRequestModel,this.voucherType).subscribe({
      next: (res) => {
        if(res?.isSuccess){
          // For Removing sum Row:
          const isSumRowTrue = (this.voucherType == PaymentVoucherTypes.MaterialOut || this.voucherType == PaymentVoucherTypes.MaterialIn || this.voucherType == PaymentVoucherTypes.PaymentVoucher || this.voucherType == PaymentVoucherTypes.ReceiptVoucher) ? false : true; 
          this.commonFilterService.processServersideApiResponse(res,this.grids.first,this.gridApi,this.pagination,this.apiRequestModel.getAll,isSumRowTrue);
        }else{
          this.hideLoading(this.gridApi);
          this.gridApi?.api?.setRowData([]);
          this.gridApi?.api?.setPinnedBottomRowData([]);
        }
      },
      error: (err) => {
          this.hideLoading(this.gridApi);          
          this.gridApi?.api?.setRowData([]);
          this.gridApi?.api?.setPinnedBottomRowData([]);
      }
    });
  }
// for Expanding Row #start-------------------

public rowClassRules: RowClassRules = 
{
    "row-border": (params) => {
      return params.data.isExpandable == true;
    },
    "expandable-grid": (params) => {
      return params.data.isExpandable == true;
    },
};

  getRowHeight(params: RowHeightParams): number | undefined | null {
    return params.data.isExpandable ? 225 : 27;
  }

  onFirstDataRendered(params: FirstDataRenderedEvent) {
    setTimeout(function () {
      params.api.getDisplayedRowAtIndex(1)!.setExpanded(true);
    }, 0);
  }

  getRowStyle(params: any) {
    return {
      background: params.node.rowIndex % 2 === 0 ? "#EEF1F7" : "#FFFFFF",
    };
  }

  textCellClick(event: any) {
    var eventData = event?.data;
    this.showExpandebleComponent(eventData);
  }

  showExpandebleComponent(event) {
    const clickedData = event;
    let expanded = 0;
    let data = this.gridApi.api?.getModel().rowsToDisplay;
    data.map((value) => {
      if (value.data.isExpandable) {
        expanded++;
      }
    });
    clickedData.isExpandable = !clickedData.isExpandable;
    this.gridApi.api.redrawRows();
  }

  gridOptions: GridOptions ={
      singleClickEdit: true,
      getRowStyle: this.getRowStyle,
    };

  // for Expanding Row #end---------------

  onPagination(pagination: PaginationModel) {
    this.storeChangedPagination(pagination);
    this.getAllVoucherData();
   }

  storeChangedPagination(paginationModel: PaginationModel) {
    this.pagination = this.commonFilterService.storeChangedPagination(paginationModel, this.pagination,this.agGridDataModelPaymentList?.paginationStorageName,this.apiRequestStorageName);
  }


openAdvanceFilterPopUp() {
  let componentToOpen;
  switch (this.voucherType) {
    case PaymentVoucherTypes.ReceiptVoucher:
      componentToOpen = ReceiptVoucherAdvancedFilterComponent;
      break;
    case PaymentVoucherTypes.PaymentVoucher:
      componentToOpen = PaymentVoucherAdvancedFilterComponent;
      break;
    case PaymentVoucherTypes.MaterialIn:
      componentToOpen = MaterialInPaymentlistAdvancedFilterComponent;
      break;
    case PaymentVoucherTypes.MaterialOut:
      componentToOpen = MaterialOutPaymentlistAdvancedFilterComponent;
      break;
    case PaymentVoucherTypes.Expense:
      componentToOpen = ExpenseAdvancedFilterPopupComponent;
      break;
    case PaymentVoucherTypes.income:
      componentToOpen = IncomeAdvanceFilterPopupComponent;
      break;
    // Add more cases here if needed
    default:
      console.warn('Unknown voucher type:', this.voucherType);
      return;
  }
  var data = { getAllDropdownModel: this.getAllDropdownModel, agGridDataModel: this.agGridDataModelPaymentList, apiRequestModel: this.apiRequestModel }
  this.notificationService.openModalPopup(componentToOpen, data, 'Advance Filter').then(
    (resultData) => {
      if (resultData) {
        // Handle the result data as needed
        this.apiRequestModel.filters = JSON.stringify(resultData.filters);
        this.storageService.store(this.apiRequestStorageName, this.apiRequestModel);
        this.filterCountValue  = this.filterCount(resultData) ;
        this.getAllVoucherData();
      }
    }
  );
}

  resetFilter(){

    this.setDefaultFilter()
  }

  ngOnDestroy(): void {
    // this.agGridDataModel.rows=[];
    this.gridApi?.api?.setRowData([]);
    this.textClickSubscriptionForTab?.unsubscribe()
  }

  callApiForExport(){
    const exportAs = this.apiRequestModel.exportAs;
    this.transactionService.getAll(this.apiRequestModel,this.voucherType).subscribe({
      next: (res) => {
      this.fileReaderService.exportFile(res, exportAs);
      },error(error) {
      console.error('Error in downloading Excel/Pdf file:', error);
      },
     }
    )
  }

  onSortIconClick(params){
    this.commonFilterService.storeChangedSortList(this.agGridDataModelPaymentList.sortStorageName , this.apiRequestStorageName);
    this.getAllVoucherData();
  }

  exportBindParameterBasedOnTab(value) {
    switch (this.voucherType) {
      case PaymentVoucherTypes.Expense:
        switch (value) {
          case ExportDropdownBindDynamicParameter.RequestModel:
            return this.apiRequestModel;
          case ExportDropdownBindDynamicParameter.GridApi:
            return [this.gridApi];
          case ExportDropdownBindDynamicParameter.GridName:
            return [StorageName.TRANSACTION_EXPENSES_PAYMENTLIST_GRID];
        }
        break;
      case PaymentVoucherTypes.income:
        switch (value) {
          case ExportDropdownBindDynamicParameter.RequestModel:
            return this.apiRequestModel;
          case ExportDropdownBindDynamicParameter.GridApi:
            return [this.gridApi];
          case ExportDropdownBindDynamicParameter.GridName:
            return [StorageName.TRANSACTION_INCOMEINVOICE_PAYMENTLIST_GRID];
        }
        break;
      case PaymentVoucherTypes.ReceiptVoucher:
        switch (value) {
          case ExportDropdownBindDynamicParameter.RequestModel:
            return this.apiRequestModel;
          case ExportDropdownBindDynamicParameter.GridApi:
            return [this.gridApi];
          case ExportDropdownBindDynamicParameter.GridName:
            return [StorageName.TRANSACTION_RECEIPTVOUCHER_PAYMENTLIST_GRID];
        }
        break;
      case PaymentVoucherTypes.PaymentVoucher:
        switch (value) {
          case ExportDropdownBindDynamicParameter.RequestModel:
            return this.apiRequestModel;
          case ExportDropdownBindDynamicParameter.GridApi:
            return [this.gridApi];
          case ExportDropdownBindDynamicParameter.GridName:
            return [StorageName.TRANSACTION_PAYMENTVOUCHER_PAYMENTLIST_GRID];
        }
        break;
      case PaymentVoucherTypes.MaterialIn:
        switch (value) {
          case ExportDropdownBindDynamicParameter.RequestModel:
            return this.apiRequestModel;
          case ExportDropdownBindDynamicParameter.GridApi:
            return [this.gridApi];
          case ExportDropdownBindDynamicParameter.GridName:
            return [StorageName.TRANSACTION_MATERIALIN_PAYMENTLIST_GRID];
        }
        break;
      case PaymentVoucherTypes.MaterialOut:
        switch (value) {
          case ExportDropdownBindDynamicParameter.RequestModel:
            return this.apiRequestModel;
          case ExportDropdownBindDynamicParameter.GridApi:
            return [this.gridApi];
          case ExportDropdownBindDynamicParameter.GridName:
            return [StorageName.TRANSACTION_MATERIALOUT_PAYMENTLIST_GRID];
        }
        break;
    }
  }

}